import {FETCH_REQUEST_DETAIL} from "../../actions/actionTypes"

const initialState = {  
    requestDetail: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    
    switch (action.type) {    
        case FETCH_REQUEST_DETAIL.REQUEST:
            return {...state,loading: true}
        case FETCH_REQUEST_DETAIL.FAILURE:
            return {...state, loading: false}
        case FETCH_REQUEST_DETAIL.SUCCESS:             
            return {...state, requestDetail: action.obj.details, loading: false}    
        default:
            return state
    }
}

export default reducer;